import { Component, Host, h, Prop, ComponentInterface } from '@stencil/core';
import { HeaderOptions } from './interfaces';
import { PredefinedColors } from '../../interface';

@Component({
    tag: 'rs-header',
    styleUrl: 'header.css',
    shadow: true
})
export class Header implements ComponentInterface {
    /** (optional) 1...5 defaults to 2 */
    @Prop() heading: HeaderOptions = '2';

    /**
     * Color of the header text
     */
    @Prop() color: PredefinedColors = 'heading';

    render() {
        const TagType = `h${this.heading}`;
        return (
            <Host style={{
                color: this.color !== undefined ? `var(--rs-color-${this.color})` : ''
            }}>
                <TagType>
                    <slot/>
                </TagType>
            </Host>
        );
    }
}